import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/7HRo6AwmH48ic6ELHM3en3/1.png', 'https://cdn.magicpatterns.com/uploads/pgprkBgEJTdDdT21gi5whE/2.png', 'https://cdn.magicpatterns.com/uploads/aprc8PvbQpjqF2QwyydtWk/3.png', 'https://cdn.magicpatterns.com/uploads/mQADBdSbedVCH6HNyhZHEJ/4.png', 'https://cdn.magicpatterns.com/uploads/wAwwPsT86j23TDh4jyYYZE/5.png', 'https://cdn.magicpatterns.com/uploads/rDHxYQM2MKgimmANLGdYZM/6.png'];
export function ProductShowcase() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 300 : -300,
      opacity: 0
    })
  };
  const swipeConfidenceThreshold = 10000;
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
  };
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setCurrentIndex(prevIndex => (prevIndex + newDirection + images.length) % images.length);
  };
  return <section className="bg-brand-dark py-12 px-5 overflow-hidden" data-id="element-261">
      <div className="max-w-xl mx-auto text-center" data-id="element-262">
        <h2 className="text-2xl md:text-3xl font-black text-white mb-4 flex items-center justify-center gap-2" data-id="element-263">
          📸 Mira el material por dentro
        </h2>

        <div className="flex items-center justify-center gap-4 text-gray-400 text-sm mb-8" data-id="element-264">
          <button onClick={() => paginate(-1)} className="p-1 hover:text-brand-yellow transition-colors" aria-label="Anterior" data-id="element-265">
            <ChevronLeft size={20} data-id="element-266" />
          </button>
          <span className="font-medium tracking-wide" data-id="element-267">
            Desliza para ver más
          </span>
          <button onClick={() => paginate(1)} className="p-1 hover:text-brand-yellow transition-colors" aria-label="Siguiente" data-id="element-268">
            <ChevronRight size={20} data-id="element-269" />
          </button>
          <span className="ml-2 text-xs opacity-60" data-id="element-270">
            {currentIndex + 1} / {images.length}
          </span>
        </div>

        <div className="relative aspect-[3/4] max-w-[320px] mx-auto mb-8" data-id="element-271">
          <AnimatePresence initial={false} custom={direction} data-id="element-272">
            <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.2
            }
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={1} onDragEnd={(e, {
            offset,
            velocity
          }) => {
            const swipe = swipePower(offset.x, velocity.x);
            if (swipe < -swipeConfidenceThreshold) {
              paginate(1);
            } else if (swipe > swipeConfidenceThreshold) {
              paginate(-1);
            }
          }} className="absolute inset-0 cursor-grab active:cursor-grabbing" data-id="element-273">
              <div className="w-full h-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-white/5 backdrop-blur-sm" data-id="element-274">
                <img src={images[currentIndex]} alt={`Vista previa del material ${currentIndex + 1}`} className="w-full h-full object-cover pointer-events-none" loading="lazy" data-id="element-275" />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Pagination dots */}
        <div className="flex justify-center gap-2" data-id="element-276">
          {images.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > currentIndex ? 1 : -1);
          setCurrentIndex(idx);
        }} className={`h-1.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-8 bg-brand-yellow' : 'w-2 bg-white/20'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-277" />)}
        </div>
      </div>
    </section>;
}